"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../index");
class RemoveBuffProcessing {
    constructor(buff, reason) {
        this.buff = buff;
        this.reason = reason;
    }
}
exports.RemoveBuffProcessing = RemoveBuffProcessing;
function removeBuffProcessor(battle, data, step) {
    const buff = data.buff;
    const index = battle.buffs.indexOf(buff);
    if (index === -1)
        return -1;
    switch (step) {
        case 1: {
            battle.addEventProcessor(index_1.EventCodes.BEFORE_BUFF_REMOVE, buff.ownerId, data);
            return 2;
        }
        case 2: {
            const target = buff.ownerId == -1 ? battle.getEntity(buff.ownerId) : null;
            battle.log(target ? `【${target.name}(${target.teamId})】` : '全局', `失去 【${buff.name}】 Buff`);
            battle.buffs.splice(index, 1);
            battle.addEventProcessor(index_1.EventCodes.BUFF_REMOVE, buff.ownerId, data);
            return -1;
        }
    }
    return 0;
}
exports.default = removeBuffProcessor;
